import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC } from 'react';
import Image from '@/components/Image';
import css from './style.module.scss';
interface Props {
  imgUrl: string;
  text: string;
  className?: string;
}
const Card: FC<Props> = t0 => {
  const $ = _c(11);
  const {
    imgUrl,
    text,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = clsx(css.card, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== imgUrl || $[3] !== text) {
    t2 = <Image src={imgUrl} className={css.image} width={300} height={300} alt={text} />;
    $[2] = imgUrl;
    $[3] = text;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== text) {
    t3 = <p className={css.caption}>{text}</p>;
    $[5] = text;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default Card;